import { Trans, useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Stack, Text } from "@similarweb/ui-components/foundations";

import { useLowQuotaBannerManagement } from "app/pages/sales-intelligence/modules/quota/hooks/useLowQuotaBannerManagement";
import { quotaKeys } from "app/pages/sales-intelligence/modules/quota/utils/i18n";

type NoTouchContentProps = {
    hasPartialCredits?: boolean;
};

const NoTouchContent = ({ hasPartialCredits = false }: NoTouchContentProps) => {
    const { translate } = useTranslate();
    const { lowCreditsBannerConfigs } = useLowQuotaBannerManagement();
    const showActionLink = lowCreditsBannerConfigs.onClick && lowCreditsBannerConfigs.buttonTextKey;

    return (
        <Stack
            gap="4px"
            data-automation="nt-not-enough-quota-content"
        >
            <Text
                fontVariant="listItem4"
                color={colorsPalettes.carbon[0]}
            >
                {hasPartialCredits
                    ? translate(quotaKeys.insufficientCreditsTitle)
                    : translate(quotaKeys.needMoreCreditsTitle)}
            </Text>

            <Text
                fontVariant="tooltip"
                color={colorsPalettes.bluegrey[100]}
            >
                <Trans i18nKey={quotaKeys.noTouchDescriptionAddon} />
            </Text>
            {showActionLink ? (
                <Text
                    as="a"
                    onClick={lowCreditsBannerConfigs.onClick}
                    fontVariant="tooltip"
                    color={colorsPalettes.blue[300]}
                    cursor="pointer"
                    data-automation="quota-data-credits-tooltip-addon-link"
                >
                    {translate(lowCreditsBannerConfigs.buttonTextKey)}
                </Text>
            ) : null}
        </Stack>
    );
};

export default NoTouchContent;
